import { useEffect, useRef } from "react";

function GoogleInput({ value, onSelect, placeholder, className }) {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (!window.google || !inputRef.current) return;
    autocompleteRef.current = new window.google.maps.places.Autocomplete(
      inputRef.current, 
      {
        fields: ["formatted_address", "geometry"],
        types: ["geocode", "establishment"] 
      }
    );

    const listener = autocompleteRef.current.addListener("place_changed", () => {
      const place = autocompleteRef.current.getPlace();
      
      if (!place || !place.geometry) return;

      if (onSelect) {
        onSelect({
          address: place.formatted_address,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        });
      }
    });

    return () => {
      if (window.google && window.google.maps && listener) {
        window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [onSelect]);

  useEffect(() => {
    if (inputRef.current && value !== undefined) {
      inputRef.current.value = value || "";
    }
  }, [value]);

  return (
    <input
      ref={inputRef}
      placeholder={placeholder}
      className={className}
      autoComplete="off"
      onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
    />
  );
}

export default GoogleInput;